// CacheProviderService.js - sessionStorage helpers (aligned with CacheContext/useCache)
const setCachevalue = (value, key) => sessionStorage.setItem(key, value);
const getCachevalue = (key) => sessionStorage.getItem(key);
const clearCachevalue = (key) => sessionStorage.removeItem(key);
const clearAllCachevalue = () => sessionStorage.clear();

const localSetItem = (key, value) => sessionStorage.setItem(key, value);
const localGetItem = (key) => sessionStorage.getItem(key);
const localClearItem = (key) => sessionStorage.removeItem(key);
const localClearAll = () => sessionStorage.clear();

export {
  setCachevalue,
  getCachevalue,
  clearCachevalue,
  clearAllCachevalue,
  localSetItem,
  localGetItem,
  localClearItem,
  localClearAll,
};
